import { matchWorksAt } from '~/models';
export function getBusinessTriggerSubtext(worksAt, texts) {
    if (!worksAt) {
        return '';
    }
    return matchWorksAt(worksAt, {
        vendor: ()=>'',
        customer: (customer)=>texts.clientOf({
                vendorName: customer.customer.vendor.name
            }),
        multiVendorCustomer: ()=>''
    });
}
export function getBusinessTriggerLogoUrl(worksAt) {
    if (!worksAt) {
        return '';
    }
    return matchWorksAt(worksAt, {
        vendor: (vendor)=>vendor.logoUrl || '',
        customer: (customer)=>customer.customer.vendor.logoUrl || '',
        multiVendorCustomer: ()=>''
    });
}
